/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ line: NonNullable<unknown> }} Einvoice_Draft_Restore_Line_LabelInputs */

const vi_einvoice_draft_restore_line_label = /** @type {(inputs: Einvoice_Draft_Restore_Line_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoàn tác xóa dòng ${i?.line}`)
};

/**

* @param {Einvoice_Draft_Restore_Line_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_restore_line_label = /** @type {((inputs: Einvoice_Draft_Restore_Line_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Restore_Line_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_restore_line_label(inputs)
});